"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.achievedMaxCapacityMessages = exports.betaBlockerMessages = exports.ableToSpiroergometryMessages = exports.AchievedMaxCapacity = exports.BetaBlocker = exports.AbleToSpiroergometry = void 0;
const schema_1 = require("../../../schema");
var AbleToSpiroergometry;
(function (AbleToSpiroergometry) {
    AbleToSpiroergometry["YES"] = "YES";
    AbleToSpiroergometry["NO"] = "NO";
})(AbleToSpiroergometry || (exports.AbleToSpiroergometry = AbleToSpiroergometry = {}));
var BetaBlocker;
(function (BetaBlocker) {
    BetaBlocker["YES"] = "YES";
    BetaBlocker["NO"] = "NO";
})(BetaBlocker || (exports.BetaBlocker = BetaBlocker = {}));
var AchievedMaxCapacity;
(function (AchievedMaxCapacity) {
    AchievedMaxCapacity["YES"] = "YES";
    AchievedMaxCapacity["NO"] = "NO";
})(AchievedMaxCapacity || (exports.AchievedMaxCapacity = AchievedMaxCapacity = {}));
exports.ableToSpiroergometryMessages = {
    [AbleToSpiroergometry.YES]: {
        id: "htx.currentCardiologicalState.cardiopulmonaryStressTest.ableToSpiroergometry.YES",
        defaultMessage: "Igen"
    },
    [AbleToSpiroergometry.NO]: {
        id: "htx.currentCardiologicalState.cardiopulmonaryStressTest.ableToSpiroergometry.NO",
        defaultMessage: "Nem"
    }
};
exports.betaBlockerMessages = {
    [BetaBlocker.YES]: {
        id: "htx.currentCardiologicalState.cardiopulmonaryStressTest.betaBlocker.YES",
        defaultMessage: "Igen"
    },
    [BetaBlocker.NO]: {
        id: "htx.currentCardiologicalState.cardiopulmonaryStressTest.betaBlocker.NO",
        defaultMessage: "Nem"
    }
};
exports.achievedMaxCapacityMessages = {
    [AchievedMaxCapacity.YES]: {
        id: "htx.currentCardiologicalState.cardiopulmonaryStressTest.achievedMaxCapacity.YES",
        defaultMessage: "Igen"
    },
    [AchievedMaxCapacity.NO]: {
        id: "htx.currentCardiologicalState.cardiopulmonaryStressTest.achievedMaxCapacity.NO",
        defaultMessage: "Nem"
    }
};
const ableToSpiroergometry = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AbleToSpiroergometry.YES),
    schema_1.Schema.singleChoiceItem(AbleToSpiroergometry.NO)
])
    .default(AbleToSpiroergometry.YES)
    .interpretation({ vocab: "htx", code: "able_to_spiroergometry" });
const betaBlocker = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(BetaBlocker.YES),
    schema_1.Schema.singleChoiceItem(BetaBlocker.NO)
])
    .optional()
    .interpretation({
    vocab: "htx",
    code: "beta_blocker_during_spiroergometry"
});
const achievedMaxCapacity = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AchievedMaxCapacity.YES),
    schema_1.Schema.singleChoiceItem(AchievedMaxCapacity.NO)
])
    .optional()
    .interpretation({ vocab: "htx", code: "achieved_max_capacity" })
    .tag({ vocab: "snomed", code: "74427007" })
    .tag({ vocab: "loinc", code: "76269-0" });
const vo2 = schema_1.Schema.number()
    .unit("ml/min/kg")
    .interpretation({ vocab: "htx", code: "vo2" })
    .tag({ vocab: "snomed", code: "7928001" })
    .tag({ vocab: "loinc", code: "60842-2" });
const value = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../ableToSpiroergometry} === "YES"`), schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ betaBlocker, achievedMaxCapacity, vo2 })
    .interpretation({ vocab: "htx", code: "spiro_fields" })
    .tag({ vocab: "snomed", code: "447346005" })
    .tag({ vocab: "snomed", code: "243806009" }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ ableToSpiroergometry, value });
